export default "/assets/images/problem-solved-09.ab85d00d77f8b640.png";